import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ArrowRight, MapPin } from 'lucide-react'
import { useLanguage } from '../../context/LanguageContext'
import { PageSlugs } from '../../constants/pageSlugs'

const CAMPUSES = [
  {
    key: 'tlaAlAli',
    slug: PageSlugs.misTlaAlAli,
    image: '/slider/001.JPG',
  },
  {
    key: 'khalda',
    slug: PageSlugs.misKhalda,
    image: '/pages/branches/khalda.png',
  },
]

export default function CampusesPageContent() {
  const { t } = useTranslation()
  const { isRTL } = useLanguage()

  return (
    <div className="space-y-8">
      <p className="text-center text-lg leading-relaxed text-text/75">{t('campusesPage.intro')}</p>

      <div className="grid gap-8 lg:grid-cols-2">
        {CAMPUSES.map(({ key, slug, image }) => (
          <Link
            key={key}
            to={`/pages/${slug}`}
            className="group block overflow-hidden rounded-2xl border border-border bg-white shadow-sm shadow-primary/5 transition-all duration-300 hover:-translate-y-1 hover:border-primary/25 hover:shadow-xl hover:shadow-primary/10"
          >
            <div className="relative h-64 overflow-hidden sm:h-72 md:h-80">
              <img
                src={image}
                alt={t(`campusCards.${key}.name`)}
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary/90 via-primary/30 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-6 text-white sm:p-8">
                <h2 className="text-2xl font-bold sm:text-3xl">{t(`campusCards.${key}.name`)}</h2>
                <p className="mt-3 flex items-center gap-2 text-sm text-white/90 sm:text-base">
                  <MapPin className="h-4 w-4 shrink-0 text-accent" />
                  {t(`campusCards.${key}.location`)}
                </p>
                <p className="mt-3 inline-flex items-center gap-2 text-sm font-semibold text-accent">
                  {t('campusesPage.viewCampus')}
                  <ArrowRight
                    className={`h-4 w-4 transition-transform group-hover:translate-x-1 ${isRTL ? 'rotate-180 group-hover:-translate-x-1' : ''}`}
                  />
                </p>
              </div>
            </div>
            <div className="p-6 sm:p-8">
              <p className="inline-block rounded-full bg-primary/5 px-3 py-1 text-xs font-semibold text-primary">
                {t(`campusCards.${key}.programs`)}
              </p>
              <p className="mt-4 text-sm leading-relaxed text-text/70 sm:text-base">
                {t(`campusCards.${key}.text`)}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  )
}
